import { useSelector } from "react-redux";
import FilterButton from "../FilterButton";
import StatsDropdownSelector from "../StatsDropdownSelector";
import styles from "./SelectionsHeader.module.scss";
import ToolTip from "../OnboardingPopup/components/ToolTip";

const SelectionsHeader = () => {
  const { onboardingStep } = useSelector((state) => state.filter);

  return (
    <div
      className={`${styles.container} ${
        onboardingStep === 1 || onboardingStep === 6
          ? styles["container--highlighted"]
          : undefined
      }`}
    >
      <h2>Selections</h2>
      <div className={styles.buttons}>
        <StatsDropdownSelector />
        <div className={styles.spacer} />
        <FilterButton />
      </div>
      {/* If onboarding is active then we show the ToolTip relative to the SelectionsHeader container */}
      {onboardingStep === 1 ? <ToolTip /> : null}
    </div>
  );
};

export default SelectionsHeader;
